export default ((items, value) => items.some(item => item === value));